<template>
  <div>
    <div id="header" class="header">
      <div class="inner">
        <div class="flexbetween">
          <!-- 左メニュー -->
          <div v-if="isDocomo" class="navigation menu-bar" />
          <div v-else class="navigation menu-bar">
            <popover name="navigation-left" :closeOnContentClick="true">
              <div class="btn-menu-bar" slot="face"><img src="static/images/icon/header/logo-s.png"></div>
              <div class="navigation-left-content" slot="content">
                <ul>
                  <li @click="goLibrary">ライブラリへ戻る</li>
                </ul>
              </div>
            </popover>
          </div>

          <div v-if="isCurrentViewHome" class="contentname lbold sp-top">{{ contentName }}</div>
          <div v-else-if="isEnvironmentPc()" class="contentname lbold">{{ contentName }} : レッスン {{ lessonIndex + 1 }} {{ pathTitle }}</div>
          <div v-else class="contentname lbold">{{ contentName }}<br>レッスン {{ lessonIndex + 1 }} {{ pathTitle }}</div>

          <div class="sp-second-header" v-show="!isCurrentViewHome">
            <div class="items flexcenter">
              <div class="progress font18"><span class="textred">{{ pathstepIndex + 1 }}</span> / {{ pathstepLength }}</div>

              <!-- setting buttons -->
              <div class="flexbox">
                <!-- 解答ボタン -->
                <div class="setting-lang" v-show="!isCurrentViewHome">
                  <popover name="answer" :closeOnContentClick="true">
                    <div slot="face">
                      <!-- 日本語表示 -->
                      <div class="btn-lang" v-if="checkJPFlg"><img src="../../static/images/icon/header/lang-ja.png"/></div>
                      <!-- 全解答 -->
                      <div class="btn-lang" v-else-if="checkAllFlg"><img src="../../static/images/icon/header/lang-en.png"/></div>
                      <!-- デフォルト -->
                      <div class="btn-lang" v-else><img src="../../static/images/icon/header/lang-en-t.png"/></div>
                    </div>
                    <div class="lang-status" slot="content">
                      <ul>
                        <li v-bind:class='{active:checkJPFlg}' v-on:click="clickJP">日本語翻訳を表示する</li>
                        <li v-bind:class='{active:checkAllFlg}' v-on:click="clickAll">全解答を表示する</li>
                      </ul>
                    </div>
                  </popover>
                </div>
                <!-- レッスンスコア -->
                <div class="setting-score" v-show="!isCurrentViewHome">
                  <div class="btn-score" v-on:click="clickLessonScore"><img src="../../static/images/icon/header/score.png"/></div>
                </div>
              </div>
            </div>
          </div>
          <!-- 右メニュー -->
          <div class="navigation menu-dots">
            <popover name="navigation-right" :closeOnContentClick="true">
              <div class="btn-menu-dots" @click="clickMenu()" slot="face"><img src="static/images/icon/header/setting-dots.png"></div>
              <div class="navigation-right-content" slot="content">
                <ul>
                  <li v-if="!isCurrentViewHome" @click="clickLogo">ホームへ戻る</li>
                  <li v-on:click="clickSettingButton">設定</li>
                  <li v-if="isDocomo || isAu" class="docomo_push">
                    <div class="flexstart"><span>プッシュ通知を許可</span><span class="push_option" :class="{ active: isEnablePush }" @click="clickNotification">ON</span><span class="push_option" :class="{ active: !isEnablePush }" @click="clickNotification">OFF</span></div>
                    <div v-if="!isAu" class="font14 lbold ml10 mt10">月に1~3回程度アップデート案内します。</div>
                    <div v-if="!isAu" class="font14 ml10"><span>らくらくスマートフォン等の非対応機種では配信されません。</span></div>
                  </li>
                  <li v-if="!isDocomo && !isAu"><a v-on:click="clickLink('help')" href="http://www.sourcenext.com/manual_sc/pc/rosettastone_advanced/home/" target="_blank" class="helptext">ヘルプ</a></li>
                  <li v-if="!isDocomo && !isAu"><a v-on:click="clickLink('readme')" href="https://www.sourcenext.com/r/p/rosettastone/eula/" target="_blank" class="readme">Rosetta Stone について</a></li>
                  <li v-if="isDocomo" @click="clickPrivacyPolicy">プライバシーポリシー</li>
                  <li v-if="isAu"><a @click="clickLink('contact')" :href="getContactUrl()" target="_blank">お問い合わせ</a></li>
                  <li v-if="isAu"><a @click="clickLink('faq')" href="http://www.sourcenext.com/r/p/au/rosetta_us/support/" target="_blank">FAQ</a></li>
                  <li v-if="isAu"><a @click="clickLink('product')" href="http://www.sourcenext.com/r/p/au/rosetta_us/product/" target="_blank">製品紹介</a></li>
                </ul>
                <div class="hintArea" v-if="note.length != 0">
                  <div class="hint"><img src="../../static/images/icon/header/hint.png"/>ヒント</div>
                  <div>{{ note }}</div>
                </div>
              </div>
            </popover>
          </div>
        </div>
      </div>
    </div>

    <!-- ログアウト画面 -->
    <Logout v-if="showLogout" @closeLogout="closeLogout" :productInfo="productInfo" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popover from "vue-popover";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";
import common from "@/mixin/common";
import Logout from "@/components/Logout";

const VIEW_NAME_RUNMODE = "Runmode";
const VIEW_NAME_HOME = "Home";

const URL_BIND_STRING_VERSION = "{VERSION}";
const URL_CONTACT_AU = "https://www.sourcenext.com/faq/cgi-bin/Inquiry002_J.cgi?type=%a5%ed%a5%bc%a5%c3%a5%bf%a5%b9%a5%c8%a1%bc%a5%f3%b1%d1%b8%ec&ver=" + URL_BIND_STRING_VERSION + "au";

export default {
  name: "toolbar",
  props: {
    currentView: String,
    jsonData: Object,
    productInfo: Object,
    isDocomo: Boolean,
    isAu: Boolean
  },
  data() {
    return {
      isCurrentViewHome: true,
      // 「日本語翻訳を表示する」選択状態フラグ
      checkJPFlg: false,
      // 「全解答を表示する」選択状態フラグ
      checkAllFlg: false,
      unitTitle: "",
      pathTitle: "",
      pathstepLength: 0,
      note: "",
      // ログアウト画面表示
      showLogout: false,
      // プッシュ通知を許可しているかを判定するフラグ
      isEnablePush: false
    };
  },
  components: {
    popover,
    Logout
  },
  mixins: [common],
  computed: {
    ...mapGetters([
      "levelNo",
      "unitNo",
      "lessonIndex",
      "pathIndex",
      "pathstepIndex",
      "showJapanese",
      "showAllAnswer"
    ]),
    contentName: function() {
      var title = "";
      if (this.isDocomo || this.isAu) {
        title = "ロゼッタストーン 日常会話";
      } else {
        title = this.productInfo.name;
      }
      return title;
    }
  },
  methods: {
    /**
     * ロゴ押下
     */
    clickLogo: function() {
      this.log("Toolbar start clickLogo");

      if (!this.isCurrentViewHome) {
        this.$emit("transitionHome");
      }
    },
    /**
     * 「日本語翻訳を表示する」押下
     */
    clickJP: function() {
      this.log("Toolbar start clickJP");

      this.checkAllFlg = false;

      // チェック済みの場合はfalseに
      if (this.checkJPFlg) {
        this.checkJPFlg = false;
      } else {
        // 未チェックの場合はtrueに
        this.checkJPFlg = true;
      }

      // 全解答/日本語翻訳表示の値を更新
      this.$store.dispatch("setShowJapanese", this.checkJPFlg);
      this.$store.dispatch("setShowAllAnswer", this.checkAllFlg);
    },
    /**
     * 「全解答を表示する」押下
     */
    clickAll: function() {
      this.log("Toolbar start clickAll");

      this.checkJPFlg = false;

      // チェック済みの場合はfalseに
      if (this.checkAllFlg) {
        this.checkAllFlg = false;
      } else {
        // 未チェックの場合はtrueに
        this.checkAllFlg = true;
      }

      // 全解答/日本語翻訳表示の値を更新
      this.$store.dispatch("setShowJapanese", this.checkJPFlg);
      this.$store.dispatch("setShowAllAnswer", this.checkAllFlg);
    },
    /**
     * レッスンスコア画面を表示
     */
    clickLessonScore: function() {
      this.log("Toolbar start clickLessonScore");

      this.audioPause(storeConstants.LESSON_STATE_PAUSE);
      this.$emit("showLessonScore");
    },
    /**
     * 「プッシュ通知を許可」押下時の動作
     */
    clickNotification: function() {
      this.log("Toolbar start clickNotification");

      // 再生中の音声を停止する。
      this.audioPause(storeConstants.LESSON_STATE_PAUSE);

      // 通知設定ダイアログの表示
      window.Phone.ShowPushSetting();
    },
    /**
     * 「プライバシーポリシー」押下時の動作
     */
    clickPrivacyPolicy: function() {
      this.log("Toolbar start clickPrivacyPolicy");

      // 再生中の音声を停止する。
      this.audioPause(storeConstants.LESSON_STATE_PAUSE);

      // プライバシーポリシー画面の表示
      window.Phone.ShowPrivacyPolicy();
    },
    /**
     * ログアウト
     */
    clickLogout: function() {
      this.log("Toolbar start clickLogout");

      this.audioPause(storeConstants.LESSON_STATE_PAUSE);

      // ログアウト確認画面表示
      this.showLogout = true;
    },
    /**
     * ログアウト画面を閉じる
     */
    closeLogout: function() {
      this.log("Toolbar start closeLogout");

      this.showLogout = false;

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * 設定画面を表示
     */
    clickSettingButton: function() {
      this.log("Toolbar start clickSettingButton");

      this.audioPause(storeConstants.LESSON_STATE_PAUSE);
      this.$emit("showSetting");
    },
    /**
     * ヘルプ/利用規約リンクを押下した場合の処理
     */
    clickLink: function(str) {
      this.log("Toolbar start clickLink: " + str);
      this.audioPause(storeConstants.LESSON_STATE_PAUSE);
    },
    /**
     * 音声停止処理
     */
    audioPause: function(lessonState) {
      this.log("Toolbar start audioPause");

      if (!this.isCurrentViewHome) {
        // state更新
        this.log("set LessonState: " + lessonState);
        this.$store.dispatch("setLessonState", lessonState);

        this.$emit("audioPause");
      }
    },
    /**
     * runmode用のdataを設定
     */
    setDataForRunmode: function() {
      this.checkJPFlg = this.showJapanese;
      this.checkAllFlg = this.showAllAnswer;

      // unitタイトル
      this.unitTitle = this.$store.getters.currentUnit.title;

      // pathタイトル
      var currentPath = this.$store.getters.currentPath;
      this.pathTitle = currentPath.title;

      if (this.pathTitle === constants.MILESTONE_TITLE) {
        // マイルストーンの場合、問題を抽出後にnoteを設定する

        // pathstep数
        this.pathstepLength = constants.MILESTONE_QUESTION_COUNT;
      } else {
        // pathstep数
        this.pathstepLength = currentPath.pathsteps.length;
        // note
        this.setNote(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex);
      }
    },
    /**
     * noteを設定
     */
    setNote: function(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex) {
      this.log("Toolbar start setNote levelNo: " + levelNo + ", unitNo: " + unitNo + ", lessonIndex: " + lessonIndex + ", pathIndex: " + pathIndex + ", pathstepIndex: " + pathstepIndex);

      var levelJson = this.getLevelJson(this.jsonData, levelNo);
      var unitJson = this.getUnitJson(levelJson, unitNo);
      this.note = unitJson.lessons[lessonIndex].paths[pathIndex].pathsteps[pathstepIndex].note;
    },
    /**
     * ライブラリ画面へ遷移する
     */
    goLibrary: function() {
      this.log("Toolbar start goLibrary");
      window.location.replace(process.env.LIBRARY_URL);
    },
    /**
     * メニュー表示時の処理
     */
    clickMenu: function() {
      this.log("Click menu");

      // ドコモ版とau版以外の場合、何もしない
      if (!this.isDocomo && !this.isAu) {
        return;
      }

      var pushStatus = window.Phone.GetPushSetting();

      // プッシュ通知許可の場合はチェックマーク付与、それ以外は何も表示しない
      if (pushStatus == 1) {
        this.isEnablePush = true;
      } else {
        this.isEnablePush = false;
      }
    },
    /**
    * お問い合わせ画面のURLを取得する
    *
    * @return {String} お問い合わせ画面URL
    */
    getContactUrl: function() {
      this.log("Toolbar start getContactUrl");

      var versionName = window.Phone.GetVersionName();
      var url = URL_CONTACT_AU.replace(URL_BIND_STRING_VERSION, versionName);

      this.log("Toolbar getContactUrl result:" + url);
      return url;
    }
  },
  watch: {
    currentView: function(newCurrentView) {
      this.log("Toolbar watch currentView: " + newCurrentView);

      if (this.currentView === VIEW_NAME_HOME) {
        this.isCurrentViewHome = true;

        this.unitTitle = "";
        this.pathTitle = "";
        this.pathstepLength = 0;
        this.note = "";
      } else {
        this.isCurrentViewHome = false;
        this.setDataForRunmode();
      }
    },
    showJapanese: function(newState) {
      this.checkJPFlg = newState;
    },
    showAllAnswer: function(newState) {
      this.checkAllFlg = newState;
    }
  },
  updated: function() {
    this.log("Toolbar start updated");

    if (this.currentView === VIEW_NAME_RUNMODE) {
      this.setDataForRunmode();
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/style/header";
</style>



// WEBPACK FOOTER //
// Toolbar.vue?8654537c